import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-session-warning',
  templateUrl: './session-warning.component.html',
  styleUrls: ['./session-warning.component.scss'],
})
export class SessionWarningComponent implements OnInit, OnDestroy {
  countdown = 60;
  private sub: Subscription | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.sub = interval(1000).pipe(take(60)).subscribe({
      next:     () => { this.countdown--; },
      complete: () => { this.activeModal.close('logout'); },
    });
  }

  stay() {
    this.activeModal.close('stay');
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
